module.exports = __webpack_public_path__ + "f507de2089913419c790d3be66ffab4c.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/PlayfairDisplay-Bold.otf
// module id = 874
// module chunks = 0